module.exports = __webpack_public_path__ + "static/media/default-marker.0fa05598.svg";